export const AdmissionSteps: Record<number, string> = {
  1: 'Children Info',
  2: "Parent's Info",
  3: 'Supplementary Info',
  4: 'Documents Attatched',
  5: 'Declaration Form',
  6: 'Fees Structure',
  7: 'ID Card Details',
};
